<template lang="pug">
  li
    template(v-if="!item.children")
      RouterLink(:to="item.path" exact)
        i(:class="item.icon")
        p {{ item.name }}
    template(v-else)
      a(
        data-toggle="collapse"
        :aria-expanded="active"
        href="javascript:"
        @click.prevent="active = !active"
      )
        i(:class="item.icon")
        p {{ item.name }}
          b.caret
      transition(name="slide")
        div.collapse.show(v-if="active")
          ul.nav
            li(v-for="(child, i) in item.children" :key="i")
              RouterLink(:to="child.path" exact)
                span.sidebar-mini-icon {{ child.name[0] }}
                span.sidebar-normal {{ child.name }}
</template>

<script>
import DashboardSidebarItem from './DashboardSidebarItem'

export default {
  components: { DashboardSidebarItem },
  props: {
    item: { type: Object, required: true }
  },
  data: () => ({
    active: false
  })
}
</script>

<style lang="sass">
a.active
  opacity: 1 !important

.slide-enter-active
  transition: max-height .4s ease-in

.slide-leave-active
  transition: max-height .4s ease-out

.slide-enter-to, .slide-leave
  overflow: hidden
  max-height: 200px

.slide-enter, .slide-leave-to
  overflow: hidden
  max-height: 0
</style>
